export { default } from './variants/ImageWithSkeleton';
export { default as Image } from './image';

export * from './types';
export * from './parts/SkeletonImage';
export * from './variants/ImageWithSkeleton';
